import React from 'react';
import PropTypes from 'prop-types';

/**
 * Shared column definition for AriesTable. The header and the body are
 * separate <table>s (so the body can scroll), so both must receive the same
 * <colgroup> to keep their columns aligned under `table-layout: fixed`.
 */
const AriesColGroup = ({ headerData }) => {
  if (!headerData.some((header) => header.width)) return null;
  return (
    <colgroup>
      {headerData.map((header, index) => (
        <col
          key={header.title + index}
          style={header.width ? { width: header.width } : undefined}
        />
      ))}
    </colgroup>
  );
};

AriesColGroup.propTypes = {
  headerData: PropTypes.array.isRequired,
};

export default AriesColGroup;
